import {first} from 'lodash';
import * as APPOINTMENT from '@/store/constants/appointment';
import {mapGetters} from "vuex";

export default {
  props: {
    patient: {
      type: Object
    }
  },

  computed: {
    ...mapGetters({
      appointments: APPOINTMENT.GET_APPOINTMENT_LIST
    }),

    /**
     * get latest appointment.
     *
     * @returns {{}}
     */
    latest_appointment() {
      console.log(this.appointments.data, 'this.appointments.data');
      return (this.appointments.data) ? first(this.appointments.data) : {};
    },

    /**
     * get last visit.
     *
     * @returns {*}
     */
    last_visit() {
      return (this.latest_appointment)
        ? this.latest_appointment.appointment_date
        : 'No Appointment record';
    }
  },

  data() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/views/Patient/Detail/js/detail-header.js